
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import Dialog from '@/components/dialog.vue';
  import UploadImg from '@/components/upload-img.vue';
  import {
    productSendsendReturnImportList,
    productSendsendReturnImport
  } from  '@/api/order'
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-dialog': Dialog,
      UploadImg,
    }
  })

  export default class ProductList extends Vue {
    private tablelist:any = []
    private tableloading = false
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
    private imShow = false
    private immsg:any = {
      ExcelFileName:'',
      ExcelFilePath:''
    }
    private importloading = false

    private mounted () {
      this.gettablelist()
    }


    private download(row){
      let url = location.origin + '/pc/order/productSend/sendReturnDownload?OrderSendReturnImportRecordId='+row.Id
      window.open(url)
    }
    private handleCloseImport(){
      this.imShow = false
      this.immsg = {
        ExcelFileName:'',
        ExcelFilePath:''
      }
    }
    private async handleConfirmImport() {
      if (!this.immsg.ExcelFilePath) {
        this.$message({
          type: 'warning',
          message: '请上传表格'
        });
        return;
      }
      try {
        this.importloading = true
        const res: any = await productSendsendReturnImport(this.immsg);
        if(res.IsSuccess){
          this.$message({
            type: 'success',
            message: '已导入，处理完成后可下载处理结果'
          });
          this.imShow = false
          this.handleCloseImport();
          this.gettablelist()
        }
      }finally{
        this.importloading = false
      }
    }
    private uploadSuc(file,name){
      this.immsg = {
        ExcelFileName:name,
        ExcelFilePath:file[0]
      }
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data = {
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        let res = await productSendsendReturnImportList(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
